import { clsx } from 'clsx';
import { useToggle } from '../../../util/toggle';
import { TextInput, type TextInputProps } from '../text-input/text-input';
import styles from './password-input.module.scss';

export type PasswordInputProps = Omit<TextInputProps, 'type'>;

export function PasswordInput({ className, disabled, ...rest }: PasswordInputProps) {
  const [isVisible, toggleVisibility] = useToggle(false);

  return (
    <TextInput
      {...rest}
      containerClassName={clsx(styles.passwordInput, className)}
      disabled={disabled}
      suffix={
        <button
          aria-label={isVisible ? 'Hide input value' : 'Show input value'}
          className={styles.toggle}
          disabled={disabled}
          onClick={toggleVisibility}
          type="button"
        >
          {isVisible ? 'Hide' : 'Show'}
        </button>
      }
      suffixClassName={styles.suffix}
      type={isVisible ? 'text' : 'password'}
    />
  );
}
